$(function() {

	// Convert images to inline svg
	pyzel.convertToSVG();

	// Init listeners for mobile menu
	pyzel.menuMobile.init();

	// Init submenu listeners
	pyzel.submenus.init();

	// Init sliders (sitewide)
	pyzel.sliders.init();

	// Demo content for static version
	// @todo refactor this in the dynamic / production version
	pyzel.surfboards.init();

	//pyzel.instagram.init();	

});